var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4"},[_c('h3',{staticClass:"note-header"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('pre',{staticClass:"note-body"},[_vm._v("        "+_vm._s(_vm.body)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }